import React from 'react'

import { useModal } from 'hooks'

// NOTE: hook that exposes delete evaluator modal state
// and handlers for other local hooks and interview components
export const useDeleteEvaluatorModal = (state, handlers) => {
  const { evaluator } = state
  const { handleRemoveEvaluator, handleSetEvaluatorId } = handlers

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleDeleteEvaluatorClose = React.useCallback(() => {
    handleSetEvaluatorId(null)
    handleClose()
  }, [handleClose, handleSetEvaluatorId])

  const handleDeleteEvaluatorOpen = React.useCallback(
    ({ uuid }) => {
      handleSetEvaluatorId(uuid)
      handleOpen()
    },
    [handleOpen, handleSetEvaluatorId],
  )

  const handleDeleteEvaluatorConfirm = React.useCallback(() => {
    handleRemoveEvaluator({ uuid: evaluator.id })
    handleDeleteEvaluatorClose()
  }, [evaluator, handleDeleteEvaluatorClose, handleRemoveEvaluator])

  return {
    handleDeleteEvaluatorClose,
    handleDeleteEvaluatorOpen,
    handleDeleteEvaluatorConfirm,
    isDeleteEvaluatorOpen: isOpen,
  }
}
